export default __webpack_public_path__ + "b9fb83c75eed2b73913e085b5d452286.jpg";